@use "variables" as *;

.endOfListWrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: $spacing-4;
  margin-bottom: $spacing-2;
  color: $content-secondary-color;
}
